function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesPowerOutletFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.999 27.881h15.938V4H7.999v23.881zM24.937 2H7a1 1 0 00-1 1v25.881a1 1 0 001 1h17.937a1 1 0 001-1V3a1 1 0 00-1-1zm-7.619 6.894a1 1 0 00-1 1v1.088a1 1 0 102 0V9.894a1 1 0 00-1-1zm-4.113 1a1 1 0 112 0v1.088a1 1 0 11-2 0V9.894zM12 12.876h7.937V8H12v4.876zm-1 2h9.937a1 1 0 001-1V7a1 1 0 00-1-1H11a1 1 0 00-1 1v6.876a1 1 0 001 1zm6.318 5.022a1 1 0 00-1 1v1.088a1 1 0 102 0v-1.088a1 1 0 00-1-1zm-4.113 1a1 1 0 112 0v1.088a1 1 0 11-2 0v-1.088zM12 23.881h7.937v-4.876H12v4.876zm-1 2h9.937a1 1 0 001-1v-6.876a1 1 0 00-1-1H11a1 1 0 00-1 1v6.876a1 1 0 001 1z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesPowerOutletFilled;